"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.worthyOfficeMain = exports.worthyOffices = exports.buyerShipmentMethods = exports.buyerPaymentMethods = exports.itemLocations = void 0;
exports.itemLocations = [
    { name: 'Ashleigh Clayton', group: 'Worthy Internal' },
    { name: 'Cheryl Garyantes', group: 'Worthy Internal' },
    { name: 'Christian Bennardello', group: 'Worthy Internal' },
    { name: 'Cindy Penate', group: 'Worthy Internal' },
    { name: 'Erik Mongno', group: 'Worthy Internal' },
    { name: 'Roy Albers', group: 'Worthy Internal' },
    { name: 'Stanley Cazeau', group: 'Worthy Internal' },
    { name: 'Vera Chumakova', group: 'Worthy Internal' },
    { name: 'Photographer', group: 'Worthy Internal' },
    { name: 'Photography', group: 'Worthy Internal' },
    { name: 'Metal', group: 'Worthy Internal' },
    { name: 'Worthy Evaluation Bin', group: 'Worthy Internal' },
    { name: 'Quick Sale', group: 'Worthy Internal' },
    { name: 'Lab Prep', group: 'Worthy Internal' },
    { name: 'Worthy NY', group: 'Worthy Internal' },
    { name: 'Avital Hajaj', group: 'Worthy Internal' },
    { name: 'Cloned items', group: 'Worthy Internal' },
    { name: 'Avital extension', group: 'Worthy Internal' },
    { name: 'Avital Post', group: 'Worthy Internal' },
    { name: 'Black Pouch', group: 'Worthy Internal' },
    { name: 'Eve Myles', group: 'Worthy Internal' },
    { name: 'Thomas Perla', group: 'Worthy Internal' },
    { name: 'Christian Gillis', group: 'Worthy Internal' },
    { name: 'Maria Deutsch', group: 'Worthy Internal' },
    { name: 'Uttam Baid', group: 'Worthy Internal' },
    { name: 'Lab - Gemologist', group: 'Worthy Internal' },
    { name: 'Shipper/Receiver', group: 'Worthy Internal' },
    { name: 'Nireesh Oommen', group: 'Worthy Internal' },
    { name: 'Roger Gallardo', group: 'Worthy Internal' },
    { name: 'Cleaning', group: 'Worthy Internal' },
    { name: '360', group: 'Worthy Internal' },
    { name: 'Lab - Admin', group: 'Worthy Internal' },
    { name: 'Jewelry Box - Return to Seller', group: 'Worthy Internal' },
    { name: 'Prepping Returns', group: 'Worthy Internal' },
    { name: 'Jewelry Box - On Hold', group: 'Worthy Internal' },
    { name: 'Ready for Lab', group: 'Worthy Internal' },
    { name: 'Prepping for Buyers', group: 'Worthy Internal' },
    { name: 'Ready to Be Shipped', group: 'Worthy Internal' },
    { name: 'Return Problem', group: 'Worthy Internal' },
    { name: 'Ready for Removal', group: 'Worthy Internal' },
    { name: 'Jewelry Box - Worthy Grading', group: 'Worthy Internal' },
    { name: 'Gemologist QC', group: 'Worthy Internal' },
    { name: 'Consignment Pipeline', group: 'Worthy Internal' },
    { name: 'AGL', group: 'Grading' },
    { name: 'GIA', group: 'Grading' },
    { name: 'IGI', group: 'Grading' },
    { name: 'Central Watch', group: 'Grading' },
    { name: 'GHI', group: 'Grading' },
    { name: 'GSI', group: 'Grading' },
    { name: 'GCAL', group: 'Grading' },
    { name: 'Gemologist - Grading - Worthy In House Quicksale', group: 'Grading' },
    { name: 'Gemologist - Grading - Worthy In House Jewelry Box', group: 'Grading' },
    { name: 'AGS', group: 'Grading' },
    { name: 'Gemologist - Grading - Worthy In House Grading', group: 'Grading' },
    { name: 'Lab - Other', group: 'Grading' },
    { name: 'Gemologist - Grading - Gia', group: 'Grading' },
    { name: 'Gemologist - Grading - Ghi', group: 'Grading' },
    { name: 'Gemologist - Grading - Igi', group: 'Grading' },
    { name: 'Diamond Removal - Other', group: 'Diamond Removal' },
    { name: 'Diamond Remove Primak', group: 'Diamond Removal' },
    { name: 'Diamond Remove Joe Klein', group: 'Diamond Removal' },
    { name: 'Diamond Remove Hon', group: 'Diamond Removal' },
    { name: 'Removal Bin', group: 'Diamond Removal' },
    { name: 'Diamond Remove Quick Jewelry Repair', group: 'Diamond Removal' },
    { name: 'Diamond Remove A.S.', group: 'Diamond Removal' },
    { name: 'Diamond Set - Other', group: 'Diamond Setting' },
    { name: 'Diamond set Primak', group: 'Diamond Setting' },
    { name: 'Diamond set Joe Klein', group: 'Diamond Setting' },
    { name: 'Reset Bin', group: 'Diamond Setting' },
    { name: 'Diamond set Quick Jewelry Repair', group: 'Diamond Setting' },
    { name: 'Remount', group: 'Diamond Setting' },
    { name: 'Diamond set Hon', group: 'Diamond Setting' },
    { name: 'Diamond set A.S.', group: 'Diamond Setting' },
    { name: 'Diamond Set - Loja', group: 'Diamond Setting' },
    { name: 'Diamond Set - Shell', group: 'Diamond Setting' },
    { name: 'Diamond Set - Xavier', group: 'Diamond Setting' },
    { name: 'Shipped back to Seller', group: 'Sent to buyer/seller' },
    { name: 'Shipped to Buyer', group: 'Sent to buyer/seller' },
    { name: 'Picked up by Buyer', group: 'Sent to buyer/seller' },
    { name: 'Pulled for Shipping', group: 'Sent to buyer/seller' },
    { name: 'Worthy Safe Setting Bin', group: 'Worthy Safe' },
    { name: 'Worthy Safe Auction Bin', group: 'Worthy Safe' },
    { name: 'Worthy Safe Return Bin', group: 'Worthy Safe' },
    { name: 'Worthy Safe Melt bin', group: 'Worthy Safe' },
    { name: 'Worthy Safe Re-Auction Bin', group: 'Worthy Safe' },
    { name: 'Pending Auction A', group: 'Worthy Safe' },
    { name: 'Pending Auction B', group: 'Worthy Safe' },
    { name: 'Pending Auction C', group: 'Worthy Safe' },
    { name: 'Pending Auction D', group: 'Worthy Safe' },
    { name: 'Pending Auction E', group: 'Worthy Safe' },
    { name: 'Pending Auction F', group: 'Worthy Safe' },
    { name: 'Pending Auction G', group: 'Worthy Safe' },
    { name: 'Pending Auction H', group: 'Worthy Safe' },
    { name: 'Pending Quicksale A', group: 'Worthy Safe' },
    { name: 'Pending Quicksale B', group: 'Worthy Safe' },
    { name: 'Pending Settings A', group: 'Worthy Safe' },
    { name: 'Pending Settings B', group: 'Worthy Safe' },
    { name: 'Pending Settings C', group: 'Worthy Safe' },
    { name: 'Pending Settings D', group: 'Worthy Safe' },
    { name: 'Pending Settings E', group: 'Worthy Safe' },
    { name: 'Pending Settings F', group: 'Worthy Safe' },
    { name: 'Pending Settings G', group: 'Worthy Safe' },
    { name: 'Pending Settings H', group: 'Worthy Safe' },
    { name: 'Pending Settings I', group: 'Worthy Safe' },
    { name: 'Pending Watches A', group: 'Worthy Safe' },
    { name: 'Pending Watches B', group: 'Worthy Safe' },
    { name: 'Evaluation A', group: 'Worthy Safe' },
    { name: 'Evaluation B', group: 'Worthy Safe' },
    { name: 'Evaluation C', group: 'Worthy Safe' },
    { name: 'Evaluation D', group: 'Worthy Safe' },
    { name: 'Evaluation E', group: 'Worthy Safe' },
    { name: 'Evaluation F', group: 'Worthy Safe' },
    { name: 'Active Auctions', group: 'Worthy Safe' },
    { name: 'Watch Active Auctions', group: 'Worthy Safe' },
    { name: 'PushBack Bin', group: 'Worthy Safe' },
    { name: 'Shipback-Returns', group: 'Worthy Safe' },
    { name: 'Return to Seller', group: 'Worthy Safe' },
    { name: 'Worthy New York', group: 'Worthy Safe' },
    { name: 'Rejects', group: 'Worthy Safe' },
    { name: 'Inventory - Worthy Buyer Bot A', group: 'Worthy Safe' },
    { name: 'Worthy Internal Inventory', group: 'Worthy Safe' },
    { name: 'Melt', group: 'Worthy Safe' },
    { name: 'Evaluation G', group: 'Worthy Safe' },
    { name: 'Evaluation H', group: 'Worthy Safe' },
    { name: 'Evaluation I', group: 'Worthy Safe' },
    { name: 'Evaluation J', group: 'Worthy Safe' },
    { name: 'Evaluation K', group: 'Worthy Safe' },
    { name: 'Evaluation L', group: 'Worthy Safe' },
    { name: 'Evaluation M', group: 'Worthy Safe' },
    { name: 'Watches Evaluation A', group: 'Worthy Safe' },
    { name: 'Watches Evaluation B', group: 'Worthy Safe' },
    { name: 'Watches Evaluation C', group: 'Worthy Safe' },
    { name: 'Watches Evaluation D', group: 'Worthy Safe' },
    { name: 'Pushback/Hold/Lost', group: 'Worthy Safe' },
    { name: 'Inventory - General A', group: 'Worthy Safe' },
    { name: 'Inventory - General B', group: 'Worthy Safe' },
    { name: 'Inventory - General C', group: 'Worthy Safe' },
    { name: 'Inventory - General D', group: 'Worthy Safe' },
    { name: 'Inventory - General E', group: 'Worthy Safe' },
    { name: 'Inventory - General F', group: 'Worthy Safe' },
    { name: 'Inventory - General G', group: 'Worthy Safe' },
    { name: 'Inventory - General H', group: 'Worthy Safe' },
    { name: 'Inventory - Worthy Buyer Bot B', group: 'Worthy Safe' },
    { name: 'Inventory - Quicksale A', group: 'Worthy Safe' },
    { name: 'Inventory - Quicksale B', group: 'Worthy Safe' },
    { name: 'Jewelry Box - Pending Quicksale', group: 'Worthy Safe' },
    { name: 'Jewelry Box - Assorted Sale', group: 'Worthy Safe' },
    { name: 'Dealer Bin A', group: 'Worthy Safe' },
    { name: 'Dealer Bin B', group: 'Worthy Safe' },
    { name: 'Sale Scheduled', group: 'Worthy Safe' },
    { name: 'Watches - Sale Scheduled', group: 'Worthy Safe' },
    { name: 'IPawn Bin', group: 'Worthy Safe' },
    { name: 'Melt - Other', group: 'Worthy Safe' },
    { name: 'Melt - Pending Sale', group: 'Worthy Safe' },
    { name: 'On Hold', group: 'Worthy Safe' },
    { name: 'Pending Sale - JB', group: 'Worthy Safe' },
    { name: 'Buyer Credits', group: 'Worthy Safe' },
    { name: 'Unresponsive Seller', group: 'Worthy Safe' },
    { name: 'Active Consignment', group: 'Worthy Safe' },
    { name: 'Lab-grown Consignment', group: 'Worthy Safe' },
];
exports.buyerPaymentMethods = {
    creditCard: 'Credit card',
    bankTransfer: 'Bank transfer',
    check: 'Check'
};
exports.buyerShipmentMethods = {
    viaCarrier: 'Via carrier',
    officePickup: 'Office pickup',
    fedex: 'Fedex',
    ferrari: 'Ferrari',
    malca: 'Malca'
};
exports.worthyOffices = {
    nycManhattan: {
        displayName: 'NYC Downtown',
        address: {
            street: '25 West 45th St.',
            floor: '2nd Floor',
            city: 'New York',
            state: 'NY',
            zip: '10036'
        },
        phone: '(888) 222-0208',
    },
};
exports.worthyOfficeMain = exports.worthyOffices.nycManhattan;
var operations = {
    itemLocations: exports.itemLocations,
    buyerPaymentMethods: exports.buyerPaymentMethods,
    buyerShipmentMethods: exports.buyerShipmentMethods,
    worthyOffices: exports.worthyOffices,
    worthyOfficeMain: exports.worthyOfficeMain
};
exports.default = operations;
//# sourceMappingURL=index.js.map